export default __webpack_public_path__ + "static/media/iconDelete.80b98473.svg";